import { Box } from '@chakra-ui/react';
import Link from 'next/link';
import { getPageInfo } from '@/config/pages';
import { BlogListItem } from '@/features/blog/components/ui/BlogList/BlogListItem';
import { RerakuBlogsQuery } from '@/graphql/generated/graphql';

type BlogListProps = {
  blogs: NonNullable<RerakuBlogsQuery['rerakuBlogs']>['items'];
}
export const BlogList = ({
  blogs
}: BlogListProps) => {
  return (
    <>
      {blogs.map((blog) =>
        <Box
          key={blog.displayId}
          _notLast={{ borderBottom: '1px solid', borderColor: 'gray.300' }}
        >
          <Link
            href={getPageInfo('studio/{slug}/blog/{id}', blog).href}
            passHref={true}
          >
            <BlogListItem
              blog={blog}
            />
          </Link>
        </Box>
      )}
    </>
  );
};
